export default __webpack_public_path__ + "static/media/parceiros.a8cc84fc.png";